import { render, staticRenderFns } from "./MemoryXForm.vue?vue&type=template&id=25756fbb&scoped=true&lang=pug&"
import script from "./MemoryXForm.vue?vue&type=script&lang=js&"
export * from "./MemoryXForm.vue?vue&type=script&lang=js&"
import style0 from "./MemoryXForm.vue?vue&type=style&index=0&id=25756fbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25756fbb",
  null
  
)

export default component.exports